import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'
import { useAbortController } from 'core/ui/hooks/useAbortController'

import { sentry } from 'legacy/utils/sentry'

import { acceptTender as acceptTenderUseCase } from '../use-cases/Tender/acceptTender'
import { rejectTender as rejectTenderUseCase } from '../use-cases/Tender/rejectTender'

export function useTenderConfirmation(id: string) {
  const abortController = useAbortController([id])
  const [acceptStatus, setAcceptStatus] = useState<RequestStatus>(RequestStatus.Initial)
  const [rejectStatus, setRejectStatus] = useState<RequestStatus>(RequestStatus.Initial)

  const acceptTender = useCallback(async () => {
    try {
      setAcceptStatus(RequestStatus.Pending)
      const load = await acceptTenderUseCase(id, abortController)
      setAcceptStatus(RequestStatus.Done)
      return load
    } catch (error) {
      if (!abortController.signal.aborted) {
        setAcceptStatus(RequestStatus.Error)
        sentry.log(error)
      }

      throw error
    }
  }, [id, abortController])

  const rejectTender = useCallback(
    async (rejectReason: string) => {
      try {
        setRejectStatus(RequestStatus.Pending)

        await rejectTenderUseCase({ id, rejectReason }, abortController)

        setRejectStatus(RequestStatus.Done)
      } catch (error) {
        if (!abortController.signal.aborted) {
          setRejectStatus(RequestStatus.Error)
          sentry.log(error)
        }

        throw error
      }
    },
    [id, abortController]
  )

  return {
    acceptStatus,
    rejectStatus,
    acceptTender,
    rejectTender,
  }
}
